import { TextInput } from '../baseInputs'

type Props = {
  helper?: string
}

const RetentionCertificate = ({ helper, ...rest }: Props) => {
  const name = 'retention_id'
  const label = 'Retention certificate'

  return <TextInput name={name} label={label} helper={helper} {...rest} />
}

export default RetentionCertificate
